import { isDefined, isNumber } from '../utils/functions.js';
import { WIDTH, HEIGHT, X, Y } from '../constants.js';
import { Scale } from './Scale.js';
import { Translation } from './Translation.js';

const AutoSizeableMixin = {
    _setScale: function () {
        const options = this.options;
        const originWidth = this._originWidth;
        const originHeight = this._originHeight;
        let scaleX = options.width / originWidth;
        let scaleY = options.height / originHeight;
        if (!isNumber(scaleX)) {
            scaleX = 1;
        }
        if (!isNumber(scaleY)) {
            scaleY = 1;
        }
        this._transform.scale = new Scale(scaleX, scaleY);
    },
    _setTranslate: function () {
        const options = this.options;
        const x = options.x || 0;
        const y = options.y || 0;
        this._transform.translate = new Translation(x, y);
    },
    _initSize: function () {
        const options = this.options;
        let transform = false;
        if (options.autoSize !== false && (isDefined(options.width) || isDefined(options.height))) {
            this._measure(true);
            this._setScale();
            transform = true;
        }
        if (isDefined(options.x) || isDefined(options.y)) {
            this._setTranslate();
            transform = true;
        }
        if (transform) {
            this._renderTransform();
        }
    },
    _updateSize: function (options) {
        let update = false;
        if (this.options.autoSize !== false && this._diffNumericOptions(options, [WIDTH, HEIGHT])) {
            update = true;
            this._measure(true);
            this._setScale();
        }
        if (this._diffNumericOptions(options, [X, Y])) {
            update = true;
            this._setTranslate();
        }
        if (update) {
            this._renderTransform();
        }
        return update;
    }
};

export { AutoSizeableMixin };
